<span class="field-view-value">{{value || '—'}}</span>
